import type { ReactNode } from "react";
import { Text } from "../../../../atoms/Text";

export interface FactProps {
  label: string;
  children: ReactNode;
}

/** One label/value pair in a hover card. Every fact is the caller's choice. */
export const Fact = ({ label, children }: FactProps) => (
  <div className="flex items-baseline justify-between gap-4 py-0.5">
    <Text
      as="span"
      variant="inherit"
      color="secondary"
      className="shrink-0 text-(length:--ledger-text-cell) leading-[1.66]"
    >
      {label}
    </Text>
    <Text
      as="div"
      variant="inherit"
      className="text-right text-(length:--ledger-text-cell) leading-[1.66] tabular-nums"
    >
      {children}
    </Text>
  </div>
);
